import { Box } from '@chakra-ui/react';
import React from 'react';
import { InsuranceInfoBasicProps } from './InsuranceInfo';


export const InsuranceInfoBasic = ({ children, sx, isSticky, ...rest }: InsuranceInfoBasicProps) => {
    let _sx: typeof sx = {
        display: { base: 'grid', md: 'flex' },
        gridTemplateAreas: '"number date" "details details"',
        rowGap: 4,
        columnGap: 8,
        // placeContent: 'space-around',
        ...sx,
    };

    if (isSticky) {
        _sx = {
            ..._sx,
            p: { lg: 4 },
            m: { lg: '-4' },
            bgColor: { lg: 'white' },
            boxShadow: { lg: 'card' },
            borderBottomRadius: { lg: 'md' },
        };
    }

    return (
        <Box sx={_sx} {...rest}>
            {children}
        </Box>
    );
};
